import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/home/home';
import Login from './components/login/login';
import Cadastro from './components/cadastro/cadastro';
import InstallPromptAndroid from './components/pwa/InstallPromptAndroid';
import IosInstallPrompt from './components/pwa/IosInstallPrompt';

// Plataforma Imports
import LayoutPlataforma from './pages/plataforma/LayoutPlataforma';
import DashboardHome from './pages/plataforma/DashboardHome';
import MeusCursos from './pages/plataforma/MeusCursos';
import MeusAgendamentos from './pages/plataforma/MeusAgendamentos';
import AgendarServico from './pages/plataforma/AgendarServico';
import MinhaConta from './pages/plataforma/MinhaConta';
import Checkout from './pages/plataforma/Checkout';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));

    const handleLogin = () => {
        setIsAuthenticated(true);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userName');
        localStorage.removeItem('userRole');
        setIsAuthenticated(false);
    };

    return (
        <Router>
            <InstallPromptAndroid />
            <IosInstallPrompt />
            <Routes>
                {/* Rota pública (Home) */}
                <Route path="/" element={<Home />} />

                {/* Rotas de autenticação */}
                <Route
                    path="/login"
                    element={<Login onLogin={handleLogin} />}
                />
                <Route
                    path="/cadastro"
                    element={<Cadastro onLogin={handleLogin} />}
                />

                {/* Rota protegida (Plataforma) */}
                <Route
                    path="/plataforma"
                    element={
                        isAuthenticated ? (
                            <LayoutPlataforma onLogout={handleLogout} />
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                >
                    <Route index element={<DashboardHome />} />
                    <Route path="cursos" element={<MeusCursos />} />
                    <Route path="agendamentos" element={<MeusAgendamentos />} />
                    <Route path="agendar" element={<AgendarServico />} />
                    <Route path="conta" element={<MinhaConta />} />
                    <Route path="checkout" element={<Checkout />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default App;